class HeaderCountrySelector extends HTMLElement {
    constructor() {
        super();
        const openLink = this.querySelector('.current-country');
        if (openLink) {
            openLink.addEventListener('click', this.toggleSelector.bind(this))
        }

    }
    toggleSelector(event) {
        event.preventDefault();
        // this.querySelector('.selector').classList.toggle('hidden');
        this.querySelector('.selector').classList.toggle('visible');
    }
}

customElements.define('header-country-selector', HeaderCountrySelector);